<template>
  <footer class="container-fluid pt-5 pb-2">
    <div class="container">
      <div class="mb-4 text-center text-md-left">
        <a
          href="https://4casters-io.gitbook.io/4casters-documentation/"
          target="_blank"
          rel="noopener"
          class="footer-link"
        >
          About
        </a>
        <router-link to="/about" class="footer-link"> Our Story </router-link>
        <router-link to="/blog" class="footer-link"> Blog </router-link>
        <router-link to="/rules" class="footer-link"> Rules </router-link>
        <router-link
          v-if="canSeeRebates(userStore.user.username)"
          to="/my-rebates"
          class="footer-link"
        >
          Rebates
        </router-link>
        <a
          href="https://docs.4casters.io/"
          target="_blank"
          rel="noopener"
          class="footer-link"
        >
          Docs
        </a>
        <a
          v-if="user.isLoggedIn"
          href="#"
          class="footer-link"
          @click.prevent="showFeedbackModal = true"
        >
          Feedback
        </a>
        <!--
        <a
          v-if="user.isLoggedIn"
          href="https://documenter.getpostman.com/view/6710109/U16gNmHG"
          target="_blank"
          rel="noopener"
          class="footer-link"
          >API
        </a>
        <a
          v-if="user.isLoggedIn"
          href="https://awnike24.github.io/4casterstreamingdocs.github.io/"
          target="_blank"
          rel="noopener"
          class="footer-link"
        >
          Streaming API
        </a>
        !-->
      </div>
      <div class="row align-items-center flex-column-reverse flex-md-row">
        <div class="col-12 col-md-6 text-center text-md-left mt-4 mt-md-0">
          <a href="mailto:hello@4casters.io" class="email-link"
            >hello@4casters.io</a
          >
          <br />
          <span>© 2026 four c bet limitada</span>
        </div>
        <div
          class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end"
        >
          <a
            href="https://twitter.com/4castersbet"
            target="_blank"
            rel="noopener"
            class="social-link"
          >
            <font-awesome-icon :icon="faTwitter" size="lg" />
          </a>
          <a
            v-if="user.isLoggedIn"
            href="https://t.me/joinchat/VDoTLW06tiqChDUj"
            target="_blank"
            rel="noopener"
            class="social-link"
          >
            <font-awesome-icon :icon="faPaperPlane" color="#ffffff" size="lg" />
          </a>
        </div>
      </div>
    </div>
    <feedback-modal
      v-if="showFeedbackModal"
      @close-modal="showFeedbackModal = false"
    />
  </footer>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane';
import { useUserStore } from '@/stores/user';
import { canSeeRebates } from '@/core/rebateUtils';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import FeedbackModal from '@/components/global/FeedbackModal.vue';

const showFeedbackModal = ref(false);
const userStore = useUserStore();
const { user } = storeToRefs(userStore);

/*
function updateLanguageType(language) {
  this.languageType = language;
  this.main.$root.main.$i18n.locale = language.key;
}
*/
</script>

<style lang="scss">
@use '@/scss/main.scss';

.footer-link {
  display: inline-block;
  &:not(:last-child) {
    margin-right: 1rem;
  }
}
footer {
  border-top: main.$border-11;
  color: main.$color-primary_01;
  background: main.$white_01;

  a.email-link {
    color: inherit;
    font-weight: bold;
  }
  a.social-link {
    width: 44px;
    height: 44px;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    line-height: 0;
    background: main.$color-primary_06;
    color: main.$white;
    border-radius: 50%;
    &:not(:last-child) {
      margin-right: 1rem;
    }

    svg {
      color: main.$white_01;
    }
  }

  img.powered-by {
    filter: main.$filter-01;
  }
}
</style>
